var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeedingLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3635 0.636353H0.63623V33.3636H33.3635V0.636353ZM24.2857 11.4515C24.951 10.8337 25.3787 11.3259 25.4688 11.869C25.98 15.2793 25.5504 18.4016 24.6073 20.9053C23.9264 22.4971 22.4577 24.7337 20.3338 24.7849C19.1863 24.8621 17.166 23.4121 18.475 19.3765C19.4966 16.2648 21.6472 13.8493 24.2857 11.4515ZM10.778 16.7912C10.3184 16.488 9.66675 16.4668 9.66721 17.3747C9.63084 20.9399 9.93921 24.1592 11.5258 27.0243C13.5942 30.7284 16.0314 30.2335 16.7552 29.3397C18.1623 27.748 17.5211 25.1498 16.817 23.568C15.6228 21.174 13.6259 18.7356 10.778 16.7912ZM13.1908 4.64888C13.4179 3.76969 14.0435 3.95376 14.4123 4.3624C16.6821 6.95856 18.0043 9.81959 18.5605 12.4365C18.8456 14.1442 18.8154 16.8201 17.0542 18.0084C16.1296 18.6923 13.6461 18.5607 12.5719 14.4564C11.7539 11.2852 12.2622 8.09106 13.1908 4.64888Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeedingLayer);
export default __webpack_public_path__ + "static/media/SeedingLayer.0d5f0a261569bde0bf4b57bf7898da6e.svg";
export { ForwardRef as ReactComponent };